import { render, staticRenderFns } from "./IdoneitaSpirografia.vue?vue&type=template&id=fcd2492c"
import script from "./IdoneitaSpirografia.vue?vue&type=script&lang=js"
export * from "./IdoneitaSpirografia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports